import axios from 'axios'

// Get data for dashboard
const get = async (iniDate, endDate) => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/analytics/${iniDate}/${endDate}`)
  return data
}

// Get details
const getDetails = async (iniDate, endDate, id) => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/analytics/${iniDate}/${endDate}/${id}`)
  return data
}

// Get export data
const getExport = async (iniDate, endDate) => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/analytics/${iniDate}/${endDate}/export`, { responseType: 'blob' })
  return data
}

export {
  get,
  getDetails,
  getExport
}
